module.exports = __webpack_public_path__ + "static/logo-c65088d10197e6962b9b7ef7f3162b6c.svg";